import * as React from 'react';
import classNames from 'classnames';
import 'react-autosuggest';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import 'tslib';
import '@invitae/ids-react';
import '../../common/VideoPopupLink/VideoPopup/VideoPopup.esm.js';
import '@invitae/add-to-cart';
import '@invitae/nucleobase-engine-contentful';
import '../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import '@invitae/nucleobase-analytics';
import '../../common/ContentfulImage/ContentfulImage.esm.js';
import '../../hooks/animation/animationContext.esm.js';
import '../../hooks/animation/classManipulation.esm.js';
import '../../types/animation.esm.js';
import '../../common/ContentfulImage/ImageContext.esm.js';
import '@invitae/nucleobase-core';
import '../../common/WrappedVideo/NvVideo/NvVideo.esm.js';
import '../../common/WrappedVideo/Vimeo/Vimeo.esm.js';
import 'react-dom';
import 'luxon';
import 'use-debounce';
import '../../GlobalTextCopyContext/GlobalTextCopyContext.esm.js';
import { MediaWrapper } from './components/MediaWrapper/MediaWrapper.esm.js';
import { TextWrapper, TEXT_POSITION } from './components/TextWrapper/TextWrapper.esm.js';
import styles from './CustomerReviewSection.module.esm.js';

var CustomerReviewSection = function (_a) {
    var _b = _a.fields, internalName = _b.internalName, heading = _b.heading, body = _b.body, customerName = _b.customerName, image = _b.image, _c = _b.textPosition, textPosition = _c === void 0 ? TEXT_POSITION.right : _c, vimeoId = _b.vimeoId, _d = _b.theme, theme = _d === void 0 ? 'ocean' : _d, analyticsEvents = _b.analyticsEvents, primaryLink = _b.primaryLink, media = _b.media, id = _a.id, dataCy = _a["data-cy"];
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: styles.root, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement("div", { className: "nv-container" },
            heading && React.createElement(BaseHeading, { className: styles.heading, heading: heading, headingAlignment: "center" }),
            React.createElement("div", { className: classNames(styles.reviewAndMediaContainer) },
                React.createElement(MediaWrapper, { image: image, media: media, theme: theme, vimeoId: vimeoId }),
                React.createElement(TextWrapper, { body: body, customerName: customerName, primaryLink: primaryLink, textPosition: textPosition, theme: theme, videoPadding: !!vimeoId || !!media })))));
};

export { CustomerReviewSection as default };
//# sourceMappingURL=CustomerReviewSection.esm.js.map
